import Vue from 'vue';
import LazyYouTubeVideo from 'vue-lazy-youtube-video';

Vue.component('lazy-youtube-video', LazyYouTubeVideo);
